// Componentes
export * from './lib/trace/trace.component';

// Servicios
export * from './lib/services/traceability.service';
export * from './lib/services/traceability.interfaces';
